<template>
    <div>
        <div class="form-actions">
            <b-button variant="primary" @click="editor.show = true">{{ $t('edit') }}</b-button>
            <b-button variant="danger" @click="remove" v-if="relation && relation.foreign != ''" class="ml-2">{{ $t('remove')
                }}</b-button>
        </div>

        <main-dialog :show="editor.show" :title="$t('editRelationships')" @close="editor.show = false">
            <b-form-group :description="this.$t('relatedFields')" :label="this.$t('schema')" label-for="component"
                :label-cols="3" :horizontal="false">
                <v-select
                    id="module"
                    v-model="relation.foreign"
                    :options="componentList"
                    taggable
                    push-tags
                    :create-option="s => s"
                    :placeholder="$t('selectOrAddCustom')"
                />
            </b-form-group>
            <b-form-group :label="this.$t('primaryKey')" label-for="keys" :label-cols="3" :horizontal="false">
                <v-select
                    id="keys"
                    v-model="primaryKey"
                    :options="primaryKeyOptions"
                    taggable
                    push-tags
                    :create-option="s => s"
                    :placeholder="$t('selectOrAddCustom')"
                />
            </b-form-group>
            <b-form-group :label="this.$t('foreignKey')" label-for="foreignKeys" :label-cols="3"
                :description="this.$t('foreignKeyCanOnlyBeUnique')" :horizontal="false">
                <v-select
                    id="foreignKeys"
                    v-model="foreignKeyValue"
                    :options="foreignKeyOptions"
                    taggable
                    push-tags
                    :create-option="s => s"
                    :placeholder="$t('selectOrAddCustom')"
                />
            </b-form-group>
            <b-form-group :label="this.$t('type')" label-for="type" :label-cols="3" :horizontal="false">
                <b-form-select id="type" :plain="false" :options="['one-to-one', 'one-to-many']" v-model="relation.type">
                </b-form-select>
            </b-form-group>
            <template #footer>
                <b-button variant="danger" v-if="relation && relation.foreign != ''" @click="remove" class="mr-2">{{ $t('remove') }}</b-button>
                <b-button variant="secondary" @click="editor.show = false" class="mr-2">{{ $t('cancel') }}</b-button>
                <b-button variant="primary" @click="save">{{ $t('save') }}</b-button>
            </template>
        </main-dialog>
    </div>
</template>

<script>
import _ from 'lodash'
import VSelect from 'vue-select'

export default {
    components: { VSelect },
    props: {
        fields: {
            type: Array
        },

        value: {
            type: Object
        },
        
        field: {
            type: Object
        }
    },
    watch: {
        value: {
            handler(newVal) {
                if (newVal) {
                    this.relation = newVal
                } else {
                    this.relation = { foreign: '', foreign_uuid: null, key: [], type: '' }
                }
                this.foreignKeys = []
            },
        },
        "relation.foreign": function () {
            const foreign = this.relation.foreign
            if (!foreign) return
            const parts = foreign.split('.')
            const componentName = parts[0]
            const schemaName = parts[1]

            this.$store.dispatch("fetchComponentsSettings", componentName).then(settings => {
                let fields = _.cloneDeep(settings.settings.fields).filter(f => {
                    if (schemaName) {
                        return f.schema && f.schema == schemaName
                    }
                    return !f.schema
                });

                fields.unshift({
                    key: "uuid",
                    module: "input",
                    type: "text"
                })

                fields.map(el => {
                    el.text = el.key
                    el.value = el.key
                })

                console.log('fields', fields)

                // TODO: update this back to proper value
                this.relation.foreign_uuid = settings.general.uuid

                this.foreignKeys = fields.filter(f => {
                    return (f.module == 'input' && (f.type == 'text' || f.type == 'number')) || f.module == 'select' && (f.type == 'relation');
                })
            });
        }
    },
    methods: {
        save() {
            if (this.relation.foreign == "" || this.relation.key.length < 2) {
                this.$bvToast.toast(this.$t('settingsRelationship'), {
                    variant: 'warning',
                    title: "Warning"
                })

                return false
            }

            this.$emit('input', this.relation)
            this.editor.show = false
        },

        remove() {
            this.relation.foreign = ""
            this.relation.foreign_uuid = null
            this.relation.key = []
            this.relation.type = ""

            this.$emit('input', this.relation)
        }
    },
    data: function () {
        return {
            editor: {
                show: false,
            },

            foreignKeys: [],
            relation: { foreign: '', foreign_uuid: null, key: [], type: '' },
        }
    },
    computed: {
        primaryKey: {
            get() { return this.relation.key[0] || '' },
            set(val) { this.$set(this.relation.key, 0, val) }
        },
        foreignKeyValue: {
            get() { return this.relation.key[1] || '' },
            set(val) { this.$set(this.relation.key, 1, val) }
        },
        primaryKeyOptions() {
            return this.fieldLists.map(f => f.value || f.key)
        },
        foreignKeyOptions() {
            return this.foreignKeys.map(f => f.value || f.key)
        },
        componentList() {
            let cm = this.$store.getters.componentsMenu

            let filtered = cm.filter(el => {
                return el.is_active
            })

            const schemas = new Set()
            filtered.forEach(component => {
                const componentSettingsData = this.$store.getters.componentSettings(component.getRef())
                if (!componentSettingsData) return;
                const { settings } = componentSettingsData
                const { fields = [] } = settings || {}

                // Regular fields
                fields.forEach(field => {
                    if (field.schema) {
                        schemas.add(`${component.getRef()}.${field.schema}`)
                    } else {
                        schemas.add(component.getRef())
                    }
                })

                // Extension fields – include schemas introduced by active extensions
                const extensions = (settings && settings.extensions) || []
                extensions.forEach(extension => {
                    if (!extension.is_active || !extension.fields) return
                    extension.fields.forEach(field => {
                        if (field.schema) {
                            schemas.add(`${component.getRef()}.${field.schema}`)
                        } else {
                            schemas.add(component.getRef())
                        }
                    })
                })
            })

            return Array.from(schemas)
        },

        fieldLists() {
            const currentSchema = this.field.schema || "default"
            let fields = this.fields.slice()
            // every model has uuid by default
            fields.unshift({
                key: "uuid",
                module: "input",
                type: "text"
            })

            let found = fields.find(f => {
                return f.key == this.field.key
            })

            if (found === undefined) {
                fields.push(this.field)
            }

            fields.map(el => {
                el.text = el.key
                el.value = el.key
            })

            console.log("FIELDS", fields, currentSchema)


            return fields.filter(f => {
                return (!f.schema && currentSchema == "default") || f.schema == currentSchema
            })
        }
    },

    mounted() {
        if (this.value != null) {
            this.relation = this.value
        }

        // Pre-fetch settings for all active components in scope so componentList computed has data to work with
        const cm = this.$store.getters.componentsMenu
        cm.filter(el => el.is_active).forEach(component => {
            this.$store.dispatch("fetchComponentsSettings", component.getRef())
        })

        if (this.relation && this.relation.foreign) {
            const foreignParts = this.relation.foreign.split('.')
            const foreignComponentName = foreignParts[0]
            this.$store.dispatch("fetchComponentsSettings", foreignComponentName).then(settings => {
                let fields = _.cloneDeep(settings.settings.fields);

                fields.unshift({
                    key: "uuid",
                    module: "input",
                    type: "text",
                    constraints: {
                        unique: true
                    }
                })

                fields.map(el => {
                    el.text = el.key
                    el.value = el.key
                })

                this.foreignKeys = fields.filter(f => {
                    return (f.module == 'input' && (f.type == 'text' || f.type == 'number')) || f.module == 'select' && (f.type == 'relation');
                }).filter(f => {
                    return f.constraints && f.constraints.unique
                })
            });
        }
    }
}
</script>
